var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryCompleteIcon = function SvgDeliveryCompleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.266 17.965h17.108v5.133a4.277 4.277 0 0 1-4.276 4.277h-8.555a4.277 4.277 0 0 1-4.277-4.277v-5.133ZM11.977 12.833h13.687c.945 0 1.71.766 1.71 1.71v3.422H10.267v-3.421c0-.945.766-1.711 1.711-1.711Z",
    stroke: "#fff",
    strokeWidth: 1.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.953 11.122v2.566M14.543 11.122v2.566",
    stroke: "#fff",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDeliveryCompleteIcon;